<div
  class="datepicker"
  [ngClass]="{
    'form__item--disabled': disabled
  }"
>
  <ion-datetime-button
    class="datepicker__button"
    [ngClass]="{
      'datepicker__button--startend': startEnd,
      'datepicker__button--required': requiredBorder,
      'datepicker__button--error': validateError
    }"
    [datetime]="mode + 'Start'"
  >
    <span slot="date-target" class="datepicker__button-content">
      <i class="fa-light fa-calendar-days datepicker__button-icon"></i>
      {{ outputDate?.start ? (outputDate.start | date:'dd LLL yyyy') :
      (startTitle | translate) }}
    </span>
  </ion-datetime-button>

  <ion-datetime-button
    *ngIf="startEnd"
    class="datepicker__button datepicker__button--end"
    [ngClass]="{
      'datepicker__button--required': requiredBorder,
      'datepicker__button--error': validateError
    }"
    [datetime]="mode + 'End'"
  >
    <span slot="date-target" class="datepicker__button-content">
      <i class="fa-light fa-calendar-days datepicker__button-icon"></i>
      {{ outputDate?.end ? (outputDate.end | date:'dd LLL yyyy') : (endTitle |
      translate) }}
    </span>
  </ion-datetime-button>
</div>

<!-- START-->
<ion-modal
  (willPresent)="setBackdrop()"
  (willDismiss)="asyncRemoveBackDrop()"
  [keepContentsMounted]="true"
  class="modal--user"
>
  <ng-template>
    <ion-datetime
      [firstDayOfWeek]="1"
      #dateStart
      data-id="start"
      id="modalStart"
      [min]="defaultMinDate"
      [locale]="locale | translate"
      [title]="startTitle | translate"
      [presentation]="presentation"
      (ionChange)="dateChanged($event, true)"
      [doneText]="'cookie.allow' | translate"
      [cancelText]="'public.checkout.cancel'| translate"
    >
      <span slot="title"> {{ startTitle | translate }} </span>
    </ion-datetime>
    <ion-button
      id="resetButtonStart"
      class="datepicker__button--hidden"
      #startReset
      (click)="dateStart.reset( focusDateStart )"
      >Reset</ion-button
    >
  </ng-template>
</ion-modal>

<!-- END -->
<ion-modal
  (willPresent)="setBackdrop()"
  (willDismiss)="asyncRemoveBackDrop()"
  [keepContentsMounted]="true"
  class="modal--user"
>
  <ng-template>
    <ion-datetime
      #dateEnd
      [firstDayOfWeek]="1"
      data-id="end"
      id="modalEnd"
      [min]="this.outputDate?.start ?? defaultMinDate"
      [locale]="locale | translate"
      [title]="endTitle | translate"
      [presentation]="presentation"
      (ionChange)="dateChanged($event)"
    >
      <span slot="title"> {{ endTitle | translate }} </span>
    </ion-datetime>
    <ion-button
      id="resetButtonEnd"
      class="datepicker__button--hidden"
      #endReset
      (click)="dateEnd.reset( focusDateEnd )"
      >Reset</ion-button
    >
  </ng-template>
</ion-modal>
